// extracted by mini-css-extract-plugin
module.exports = {"ratings-reviews-tab-container":"RatingsAndReviewTab_ratings-reviews-tab-container__2R0fG","review-heading":"RatingsAndReviewTab_review-heading__eMh0G"};